import { createTheme } from "@mui/material/styles";

// Design tokens shared with style.css (see CSS custom properties in :root)
// so the MUI layer and the hand-written CSS layer stay visually in sync.
const ink = "#192e2b";
const paper = "#ffffff";
const surface = "#f7f8f4";
const border = "#e0e5df";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: ink,
      contrastText: paper,
    },
    secondary: {
      main: "#676767",
      contrastText: paper,
    },
    background: {
      default: surface,
      paper: paper,
    },
    text: {
      primary: "#212529",
      secondary: "rgba(45, 55, 72, 0.77)",
    },
    divider: border,
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        // Keyboard users still get a visible ring (see .MuiButtonBase-root:focus-visible
        // in style.css) — only the mouse-click "flash" ripple focus is removed here.
        disableRipple: false,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: "0 8px 24px rgba(20, 20, 20, 0.25)",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "medium",
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          backgroundColor: ink,
          color: paper,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: ink,
          fontSize: "0.75rem",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(20, 20, 20, 0.6)",
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(20, 20, 20, 0.08)",
        },
      },
    },
  },
});

export default theme;
